import { DATE_FORMAT, formatGridDate } from '~/utils/data-grid.format';
import { getGridStyle } from '~/utils/data-grid.style';
import { getPartnerCurrency } from '~/utils/data-grid.storage';

export const useDataGridFormatters = () => {
  const { $i18n } = useNuxtApp();
  const { n, locale } = $i18n;
  const currency = getPartnerCurrency();

  const dateFormat = computed(() => DATE_FORMAT);

  const handleDataGridDate = (date?: string): string => {
    return formatGridDate(date, locale.value);
  };

  const getCurrency = (data: number | null | undefined): string => {
    return n(data ?? 0, { style: 'currency', currency, currencyDisplay: 'narrowSymbol' });
  };

  const getStyle = (type: string, value: number) => {
    return getGridStyle(type, value);
  };

  return { dateFormat, handleDataGridDate, getCurrency, getStyle };
};
